var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"word"},_vm._l((_vm.lists),function(list,index){return _c('li',{key:index,class:_vm.selected===list.id?'active':'',on:{"click":function($event){return _vm.$emit('changed', list)}}},[_c('span',[_vm._v(_vm._s(_vm.lang[list.lang] || list.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }